import React, { useState } from 'react';
import { Modal, Button, Form, Table, Alert, Spinner } from 'react-bootstrap';
import { parseInvoiceImage, importInvoiceItems } from '../http/invoiceAPI';
import { fetchStores, fetchCategories } from '../http/productAPI';

const typeOptions = [
  { value: 'shoe', label: 'Обувь' },
  { value: 'clothes', label: 'Одежда' },
  { value: 'toy', label: 'Игрушки' },
  { value: 'other', label: 'Прочее' }
];

const InvoiceOcrModal = ({ show, onHide, invoiceId, onImported }) => {
  const [file, setFile] = useState(null);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [categories, setCategories] = useState([]);

  React.useEffect(() => {
    fetchStores().then(setStores).catch(()=>{});
    fetchCategories().then(setCategories).catch(()=>{});
  }, []);

  const handleParse = async () => {
    if (!invoiceId) { setError('Не выбрана накладная'); return; }
    if (!file) { setError('Выберите фото накладной'); return; }
    setError(''); setLoading(true);
    try {
      const res = await parseInvoiceImage(invoiceId, file);
      const parsed = Array.isArray(res.items) ? res.items : [];
      setRows(parsed);
    } catch (e) {
      setError(e?.response?.data?.message || 'Ошибка распознавания');
    } finally {
      setLoading(false);
    }
  };

  const updateRow = (idx, field, value) => setRows(prev => prev.map((r,i)=> i===idx ? { ...r, [field]: value } : r));

  const handleImport = async () => {
    if (!rows.length) { setError('Нет строк для импорта'); return; }
    const payload = { invoiceId, items: rows };
    setLoading(true); setError('');
    try {
      await importInvoiceItems(payload);
      if (onImported) onImported();
      onHide();
      setRows([]);
      setFile(null);
    } catch (e) {
      setError(e?.response?.data?.message || 'Ошибка импорта');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Распознать накладную (фото/скан)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <div className="d-flex gap-2 mb-3 align-items-center flex-wrap">
          <Form.Control type="file" accept="image/*,application/pdf" onChange={e=>setFile(e.target.files?.[0]||null)} style={{ maxWidth: 360 }} />
          <Button variant="primary" onClick={handleParse} disabled={loading}>Распознать</Button>
        </div>

        {loading && <div className="text-center py-3"><Spinner animation="border" /></div>}

        {rows.length > 0 && (
          <div className="table-responsive" style={{ maxHeight: 420, overflow: 'auto' }}>
            <Table bordered hover size="sm" className="align-middle text-nowrap">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Кол-во</th>
                  <th>Закупка</th>
                  <th>Наценка %</th>
                  <th>Тип</th>
                  <th>Магазин</th>
                  <th>Штрих-код</th>
                  <th>Размер</th>
                  <th>Цвет</th>
                  <th>Категория</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={idx}>
                    <td><Form.Control value={r.name||''} onChange={e=>updateRow(idx,'name',e.target.value)} /></td>
                    <td style={{width:90}}><Form.Control type="number" min="0" value={r.quantity||''} onChange={e=>updateRow(idx,'quantity',e.target.value)} /></td>
                    <td style={{width:110}}><Form.Control type="number" min="0" step="0.01" value={r.purchasePrice||''} onChange={e=>updateRow(idx,'purchasePrice',e.target.value)} /></td>
                    <td style={{width:90}}><Form.Control type="number" value={r.markup||20} onChange={e=>updateRow(idx,'markup',e.target.value)} /></td>
                    <td style={{width:130}}>
                      <Form.Select value={r.type||'other'} onChange={e=>updateRow(idx,'type',e.target.value)}>
                        {typeOptions.map(opt=>(<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                      </Form.Select>
                    </td>
                    <td style={{width:160}}>
                      <Form.Select value={r.store_id||''} onChange={e=>updateRow(idx,'store_id',e.target.value)}>
                        <option value="">Магазин</option>
                        {stores.map(s=>(<option key={s.id} value={s.id}>{s.name}</option>))}
                      </Form.Select>
                    </td>
                    <td style={{width:120}}><Form.Control value={r.barcode||''} onChange={e=>updateRow(idx,'barcode',e.target.value)} /></td>
                    <td style={{width:100}}><Form.Control value={r.size||''} onChange={e=>updateRow(idx,'size',e.target.value)} /></td>
                    <td style={{width:100}}><Form.Control value={r.color||''} onChange={e=>updateRow(idx,'color',e.target.value)} /></td>
                    <td style={{width:160}}>
                      <Form.Select value={r.category_id||''} onChange={e=>updateRow(idx,'category_id',e.target.value)}>
                        <option value="">Без категории</option>
                        {categories.map(c=>(<option key={c.id} value={c.id}>{c.name}</option>))}
                      </Form.Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Отмена</Button>
        <Button variant="primary" onClick={handleImport} disabled={loading || rows.length===0}>Импортировать</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceOcrModal;

